export const getNumberIndex = (index: number, subIndex?: number) => {
  return subIndex ? `${index}.${subIndex}` : `${index}.`;
};

export const getEmptyIndex = () => '';
